import React from 'react';
import { CheckList } from './CheckList';
import { SparklesIcon } from 'lucide-react';
export function SolutionSection() {
  const problemItems = ['correcciones', 'regaños', 'presión', 'obligación'];
  const solutionItems = ['diversión', 'amigos', 'juegos', 'pertenencia', 'libertad'];
  return <section className="py-16 px-4 bg-gradient-to-b from-orange-50 to-amber-50" data-id="element-113">
      <div className="max-w-5xl mx-auto" data-id="element-114">
        <div className="text-center mb-12" data-id="element-115">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-900 mb-6 uppercase tracking-tight" data-id="element-116">
            El problema real no es el idioma. Es la emoción asociada al idioma.
          </h2>
        </div>

        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-xl mb-12" data-id="element-117">
          <h3 className="font-serif text-3xl font-bold text-center mb-8 text-gray-900" data-id="element-118">
            Aquí está el descubrimiento que lo cambia todo:
          </h3>

          <div className="bg-amber-100 p-6 rounded-lg border-2 border-amber-500 mb-8" data-id="element-119">
            <p className="text-2xl font-bold text-center text-gray-900" data-id="element-120">
              Los niños no rechazan el español.
            </p>
            <p className="text-2xl font-bold text-center text-amber-700 mt-2" data-id="element-121">
              Rechazan cómo se les presenta el español.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-8" data-id="element-122">
            <div data-id="element-123">
              <h4 className="text-xl font-bold mb-4 text-gray-900" data-id="element-124">
                El español se les presenta como:
              </h4>
              <CheckList items={problemItems} variant="x" data-id="element-125" />
            </div>

            <div data-id="element-126">
              <h4 className="text-xl font-bold mb-4 text-gray-900" data-id="element-127">
                Mientras que el inglés se les presenta como:
              </h4>
              <CheckList items={solutionItems} variant="check" data-id="element-128" />
            </div>
          </div>

          <p className="text-xl text-center font-semibold text-gray-700" data-id="element-129">
            Adivina cuál idioma prefieren…
          </p>
        </div>

        <div className="bg-gradient-to-r from-amber-500 to-orange-500 p-8 md:p-12 rounded-2xl shadow-2xl text-white" data-id="element-130">
          <div className="flex items-center justify-center gap-3 mb-6" data-id="element-131">
            <SparklesIcon size={32} data-id="element-132" />
            <h3 className="font-serif text-3xl md:text-4xl font-bold text-center" data-id="element-133">
              LA CONVERSIÓN EMOCIONAL DEL ESPAÑOL™
            </h3>
            <SparklesIcon size={32} data-id="element-134" />
          </div>

          <p className="text-xl text-center mb-8 leading-relaxed" data-id="element-135">
            El método que activa el español sin presión, sin peleas y sin
            regaños
          </p>

          <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg" data-id="element-136">
            <p className="text-lg leading-relaxed mb-6" data-id="element-137">
              Después de estudiar familias bilingües, hablar con educadores y
              probar estrategias reales, descubrí la clave:
            </p>
            <p className="text-2xl font-bold text-center" data-id="element-138">
              El español no se pierde por falta de vocabulario. Se pierde por
              falta de vínculo emocional.
            </p>
          </div>
        </div>
      </div>
    </section>;
}